import * as React from 'react';
import { ColumnProps } from 'antd/lib/table';
import { Row, Col, Card, Icon, Button, Tabs, List, Avatar, Divider } from 'antd';

import { Account, SlimOffering, OfferingStatus } from 'Core/Api/Api';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
import DetailsMode from 'Core/models/DetailsMode';
import { ClientIpoHandler } from '../../../Client/ClientIpoHandler';
import DetailsData from '../../../../Core/models/DetailsData';
import { encode } from 'punycode';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { BrandedLink } from '../../../Styled/Branded/BrandedLink'
import { BrandedButton } from '../../../Styled/Branded/BrandedButton';
import IfNotLoggedInModal from '../../../Forms/IfNotLoggedInModal';
import { GeneralApplyNowLink } from '../../../Offering/OfferingDetailsView';
import AuthContext from '../../../../Context/AuthContext';
import { startCase } from 'lodash';
import { FullWithButton } from '../../../Forms/Form.Styled';
import Title from 'antd/lib/typography/Title';

const { TabPane } = Tabs;

export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    offerings: SlimOffering[];
}

export default class DashboardViewCard extends React.Component<Props, State> {
    handler: ClientIpoHandler;
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props);

        this.state = {
            offerings: []
        };
        this.handler = new ClientIpoHandler(props);
    }

    componentDidMount() {
        this.getOfferings();
    }

    getOfferings() {
        this.handler.GetOfferingsForDashboard().then(x => {
            this.setState({ offerings: x.results ?? [] }
            );
        });
    }

    generalApplyClicked(id: string | undefined) {
        if (id) {
            if (this.context.data) {
                this.props.history.push(
                    `/ipo/apply/${id}`,
                    new DetailsData(DetailsMode.New, id)
                );
            } else {
            }
        }
    };

    render() {
        const { Meta } = Card;
        const IconText = ({ type, text }) => (
            <span>
                <Icon type={type} style={{ marginRight: 8 }} />
                {text}
            </span>
        );

        return (
            <div>
                <Row gutter={16} type={'flex'}>
                    {
                        this.state.offerings?.map(item => {
                            return <Col xs={24} xl={12} xxl={8} style={{ marginBottom: '10px' }}>
                                <Card style={{
                                    backgroundColor: 'white', height: '100%'
                                }}
                                    actions={[
                                        <Row style={{ padding: '15px' }} gutter={16}>
                                            <Col xs={12} style={{ textAlign: 'right' }}>
                                                {item.status == OfferingStatus.PreOpen || item.status == OfferingStatus.Opened ?
                                                    <IfNotLoggedInModal offeringId={item.id} >
                                                        <GeneralApplyNowLink onClick={this.generalApplyClicked.bind(this, item.id)}>
                                                            <span style={{ fontWeight: 'bold' }}>Apply Now</span>
                                                        </GeneralApplyNowLink>
                                                    </IfNotLoggedInModal>
                                                    : <GeneralApplyNowLink disabled>
                                                        <span style={{fontWeight:'bold'}}>Apply Now</span>
                                                    </GeneralApplyNowLink>
                                                }
                                            </Col>
                                            <Col xs={12}  >
                                                <BrandedLink style={{}}
                                                    to={{
                                                        pathname: 'ipo/details/' + encodeURI(item.id ?? ''),
                                                        state: { ipoId: item.id, mode: DetailsMode.New }
                                                    }}>
                                                    <Button style={{ color: '#F0403D', borderColor: '#F0403D', width: '100%', fontWeight: 'bold' }} ghost>View Details</Button>

                                </BrandedLink>
                                            </Col>
                                        </Row>
                                    ]}
                                    title={<Row>
                                        <Col xs={24} sm={12}>
                                            <span style={{ fontSize: '19px', color:'#202020'}}>  {item.title}</span>
                                        </Col>

                                    </Row>} >
                                    <Row>
                                        <Col xs={24} md={12} xl={10}>
                                            <div className="center-avatar"> <Avatar src={item.fileUrl} size={128} shape="square" />
                                            </div>
                                            
                                        </Col>
                                        <Col xs={24} md={12} xl={14}>
                                            <Row><Col><b>Status: </b><span className={'offering-status ' + item.status} style={{ float: 'right' }}>  {startCase(item.status)}</span></Col></Row>
                                            <Divider/>
                                            <Row><Col><b>Currency: </b><span style={{ float: 'right' }}> {item.currency}</span></Col></Row>
                                            <div><Row><Col><b>General Share Unit Price: </b> <NumberFormat style={{ float: 'right' }} value={item.generalSharePrice} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} /> </Col></Row>
                                                <Row><Col><b>General Share Amount: </b>  <NumberFormat style={{ float: 'right' }} value={item.generalShareAmount} displayType={'text'} thousandSeparator={true} /> </Col></Row>
                                                <Row><Col><b>Opening Date: </b><span style={{ float: 'right' }}>  {moment(item.openingDate)?.format('MMMM D, YYYY')}</span></Col></Row>
                                                <Row><Col><b>Closing Date: </b><span style={{ float: 'right' }}>  {moment(item.closingDate)?.format('MMMM D, YYYY')}</span></Col></Row>
                                            </div>
                                        </Col>


                                    </Row>

                                </Card>
                            </Col>
                        })
                    }
                </Row>
            </div>
        );
    }
}



